import { Popconfirm } from "antd";
import type { PopconfirmProps } from "antd";
import React from "react";

export interface ConfirmActionProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  onConfirm: PopconfirmProps["onConfirm"];
  onCancel?: PopconfirmProps["onCancel"];
  children: React.ReactNode;
  okText?: string;
  cancelText?: string;
  okButtonProps?: PopconfirmProps["okButtonProps"];
  cancelButtonProps?: PopconfirmProps["cancelButtonProps"];
  disabled?: boolean;
  placement?: PopconfirmProps["placement"];
  overlayClassName?: string;
}

/**
 * Shared confirm-before-proceed wrapper (Ant Design Popconfirm).
 * Use for logout, delete, and any action that needs user confirmation.
 */
const ConfirmAction: React.FC<ConfirmActionProps> = ({
  title = "Are you sure you want to proceed?",
  description,
  onConfirm,
  onCancel,
  children,
  okText = "Yes",
  cancelText = "No",
  okButtonProps,
  cancelButtonProps,
  disabled,
  placement = "top",
  overlayClassName,
}) => {
  return (
    <Popconfirm
      title={title}
      description={description}
      onConfirm={onConfirm}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
      okButtonProps={okButtonProps}
      cancelButtonProps={cancelButtonProps}
      disabled={disabled}
      placement={placement}
      overlayClassName={overlayClassName}
    >
      {children}
    </Popconfirm>
  );
};

export default ConfirmAction;
